import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=ac9d58d4&scoped=true&"
import script from "./notifications.vue?vue&type=script&lang=js&"
export * from "./notifications.vue?vue&type=script&lang=js&"
import style0 from "./notifications.vue?vue&type=style&index=0&id=ac9d58d4&prod&lang=sass&scoped=true&"
import style1 from "./notifications.vue?vue&type=style&index=1&id=ac9d58d4&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9d58d4",
  null
  
)

export default component.exports